"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _priceShared = require("@ingka/price-shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Price = props => {
  const {
    prefix = '',
    decimalSign,
    subscriptLabel,
    integerValue,
    decimalValue,
    size = 'medium',
    fixedSize,
    currencyVerticalAlignment = 'super',
    decimalVerticalAlignment = 'super',
    currencyLabel,
    currencySpacing = 'none',
    captionPrefix,
    captionSuffix,
    currencyPosition = 'leading',
    regularFontWeight,
    strikeoutPrice,
    bti,
    subtle,
    className,
    ...other
  } = props;
  const baseClass = `${prefix}price`;
  const classes = (0, _priceShared.priceClasses)({
    baseClass,
    currencyLabel,
    currencyPosition,
    currencySpacing,
    strikeoutPrice,
    fixedSize,
    currencyVerticalAlignment,
    decimalVerticalAlignment,
    subtle,
    bti,
    size,
    regularFontWeight,
    className
  });
  const PriceElement = (0, _priceShared.getElementType)({
    bti
  });
  const negativeSign = (0, _priceShared.getNegativeSign)({
    integerValue
  });
  const ariaLabel = (0, _priceShared.generateAriaLabel)({
    captionPrefix,
    captionSuffix,
    negativeSign,
    currencyLabel,
    currencyPosition,
    decimalSign,
    decimalValue,
    subscriptLabel,
    integerValue
  });
  return _react.default.createElement(PriceElement, _extends({
    className: classes
  }, other), _react.default.createElement("span", {
    "aria-hidden": true
  }, negativeSign && _react.default.createElement("span", {
    className: `${baseClass}__minus`
  }, negativeSign), currencyPosition === 'leading' && _react.default.createElement("span", {
    className: `${baseClass}__currency`
  }, currencyLabel), _react.default.createElement("span", {
    className: `${baseClass}__integer`
  }, negativeSign ? integerValue.slice(1) : integerValue), decimalSign && decimalValue && _react.default.createElement("span", {
    className: `${baseClass}__decimal`
  }, _react.default.createElement("span", {
    className: `${baseClass}__separator`
  }, decimalSign), decimalValue.trim()), currencyPosition === 'trailing' && _react.default.createElement("span", {
    className: `${baseClass}__currency`
  }, currencyLabel), subscriptLabel && _react.default.createElement("span", {
    className: `${baseClass}__subscript`
  }, subscriptLabel)), _react.default.createElement("span", {
    className: `${baseClass}__sr-text`
  }, ariaLabel));
};
var _default = Price;
exports.default = _default;